<template>
  <BreadCrumb PageTitle="Vertical Alignment" />
  <VerticalAlignment />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import VerticalAlignment from "../../template-components/Utilities/VerticalAlignment/VerticalAlignment.vue";

export default defineComponent({
  name: "VerticalAlignmentPage",
  components: {
    BreadCrumb,
    VerticalAlignment,
  },
});
</script>